import { Injectable } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Person } from '../../types/person/person';

@Injectable()
export class UserCountFormHelperService {

  constructor(private _fb: UntypedFormBuilder) {
  }

  buildUserCountForm() {
    return this._fb.group({
      dateFrom: [''],
      dateTo: [''],
      region: [''],
      country: ['']
    });
  }

  initPersonForm(form: UntypedFormGroup, person: Person) {
    form.patchValue(person);
  }

}
